import AnimatedComponent from '../abstracts/AnimatedComponent';

export default class ArticleHeaderComponent extends AnimatedComponent {
    constructor(compEl) {
        console.log('ArticleHeaderComponent init');
        super(compEl);

        const headerBase = document.querySelector("#articleHeaderBase")
        const headerClone = document.querySelector("#articleHeaderClone")

        if (headerBase && headerClone) {
            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio !== 1) {
                        headerClone.style.display = "flex";
                    } else {
                        headerClone.style.display = "none";
                    }
                })
            }, {
                threshold: 1
            });

            observer.observe(headerBase);
        }
    }

    init() {
        super.init();
    }
}
